import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import BreadcrumbContainer from '../controls/BreadcrumbContainer'
import OrganizationUserList from './OrganizationUserList'

import * as OrganizationActionCreators from '../../actions/organization'
import * as PermissionActionCreators from '../../actions/permission'

class OrganizationUsersContainer extends React.Component {
  static propTypes = {
    /* passed props */
    organizationId: PropTypes.string.isRequired,
    /* mapped state */
    organizations: PropTypes.object.isRequired,
    roles: PropTypes.object.isRequired,
    /* mapped dispatch */
    organizationActions: PropTypes.object.isRequired,
    permissionActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      organizations: state.organizations,
      roles: state.roles,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      organizationActions: bindActionCreators(OrganizationActionCreators, dispatch),
      permissionActions: bindActionCreators(PermissionActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.props.permissionActions.listRoles()
  }

  render() {
    const {
      organizations, roles, organizationId, organizationActions,
    } = this.props
    const organization = organizations[organizationId]

    if (organization) {
      return (
        <>
          <BreadcrumbContainer items={[
            { title: `${organization.name} Users` },
          ]}
          />

          <OrganizationUserList
            organization={organization}
            roles={roles}
            onAdd={organizationActions.addOrganizationUser}
            onRemove={organizationActions.updateOrganization}
          />
        </>
      )
    }

    return (
      <>
        loading
      </>
    )
  }
}

export default connect(
  OrganizationUsersContainer.mapStateToProps,
  OrganizationUsersContainer.mapDispatchToProps,
)(OrganizationUsersContainer)
